import React, { useState, useEffect } from "react";
import { Button, Container, Row, Col } from "react-bootstrap";
import { FaFacebookF, FaTwitter, FaInstagram } from "react-icons/fa";
import {
  RiSecurePaymentLine,
  RiLockPasswordFill,
  RiShieldCheckFill,
} from "react-icons/ri";
import { SiTripadvisor } from "react-icons/si";
import { useBrandingContext } from "./BrandingContext";
import { useHotelInfoContext } from "./HotelInfoContext";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();
  const [footerColor, setFooterColor] = useState("#433d80");

  // Be defensive: the context may be null before the provider mounts.
  const hotelCtx = useHotelInfoContext() || {};
  const ctxHotelInfo = hotelCtx.hotelInfo || null;
  const brandingCtx = useBrandingContext() || {};
  const ctxBranding = brandingCtx.branding || null;

  useEffect(() => {
    if (ctxBranding) setFooterColor(ctxBranding.footerColor || "#433d80");
  }, [ctxBranding]);

  // Limit description to ~20 words as a short summary
  const hotel = ctxHotelInfo || {};
  const social = hotel.socialMediaLinks || {};
  const trimmedDescription = hotel.description
    ? hotel.description.split(" ").slice(0, 20).join(" ") + "..."
    : "We are creating high-quality resources and tools to aid developers during the development of their projects.";

  return (
    <footer
      className="footer text-light py-6"
      style={{ backgroundColor: footerColor }}
    >
      <Container>
        <Row>
          <Col md={6} className="mb-2">
            <a
              href="/"
              className="d-flex align-items-center text-light"
              style={{ textDecoration: "none" }}
            >
              <img
                alt="logo"
                src={hotel.logo || "/whitelogo2.png"}
                width="150px"
              />
            </a>
            <p className="my-3" style={{ width: "350px" }}>
              {trimmedDescription}
            </p>
            <div className="mt-4">
              {social.facebook && (
                <a
                  href={social.facebook}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Button variant="link" className="text-light me-2">
                    <FaFacebookF />
                  </Button>
                </a>
              )}
              {social.twitter && (
                <a
                  href={social.twitter}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mx-3"
                >
                  <Button variant="link" className="text-light">
                    <FaTwitter />
                  </Button>
                </a>
              )}
              {social.instagram && (
                <a
                  href={social.instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Button variant="link" className="text-light">
                    <FaInstagram />
                  </Button>
                </a>
              )}
              {social.tripadvisor && (
                <a
                  href={social.tripadvisor}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="ms-3"
                >
                  <Button variant="link" className="text-light">
                    <SiTripadvisor />
                  </Button>
                </a>
              )}
            </div>
          </Col>
          <Col md={2} className="mt-3">
            <p className="h5" style={{ fontWeight: "600" }}>
              {t("footer.legal")}
            </p>
            <ul className="list-unstyled">
              <li>
                <a
                  href="/cookie-settings"
                  className="text-light text-decoration-none"
                >
                  {t("footer.cookie_settings")}
                </a>
              </li>
              <li>
                <a
                  href="/terms-of-service"
                  className="text-light text-decoration-none"
                >
                  {t("footer.terms_of_service")}
                </a>
              </li>
              <li>
                <a
                  href="/privacy-policy"
                  className="text-light text-decoration-none"
                >
                  {t("footer.privacy_policy")}
                </a>
              </li>
            </ul>
          </Col>
          <Col md={2} className="mt-3">
            <p className="h5" style={{ fontWeight: "600" }}>
              {t("footer.help")}
            </p>
            <ul className="list-unstyled">
              <li>
                <a href="/support" className="text-light text-decoration-none">
                  {t("footer.support")}
                </a>
              </li>
              <li>
                <a href="/sign-up" className="text-light text-decoration-none">
                  {t("footer.sign_up")}
                </a>
              </li>
              <li>
                <a href="/sign-in" className="text-light text-decoration-none">
                  {t("footer.sign_in")}
                </a>
              </li>
            </ul>
          </Col>
          <Col
            md={2}
            className="mt-3 mb-3 d-flex align-items-start justify-content-center"
          >
            <div className="text-right">
              <RiLockPasswordFill
                className="text-light me-2"
                size={30}
                title="SHA-256 Encryption"
              />
              <RiSecurePaymentLine
                className="text-light me-2"
                size={30}
                title="Book Securely"
              />
              <RiShieldCheckFill
                className="text-light"
                size={30}
                title="PCI DSS Compliant"
              />
            </div>
          </Col>
        </Row>
        <small className="text-center d-block">
          &copy; Chiic World Vietnam Jsc, 2024.{" "}
          {t("footer.all_rights_reserved")}
        </small>
      </Container>
    </footer>
  );
};

export default Footer;
